/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { isUploaded } from '@blend/enterprise-components';
import { every } from 'lodash';
export const canSubmit = uploads => {
  return every(uploads, _ref => {
    let {
      upload
    } = _ref;
    return isUploaded(upload);
  });
};